export default __webpack_public_path__ + "static/media/mke-zoo-orangutans.f8d3fe0e.jpg";